import styled from "styled-components"
interface IAutomationCentreWrapperProps {
	$lang: "ar" | "en"
	$inDrawer?: boolean
}
export const AutomationCentreWrapper = styled.div<IAutomationCentreWrapperProps>`
	width: ${(props) => (props.$inDrawer ? "100%" : "33%")};
	height: ${(props) => (props.$inDrawer ? "auto" : "100dvh")};
	position: ${(props) => (props.$inDrawer ? "static" : "absolute")};
	left: ${(props) =>
		props.$inDrawer ? "auto" : props.$lang === "ar" ? 0 : "auto"};
	right: ${(props) =>
		props.$inDrawer ? "auto" : props.$lang === "en" ? 0 : "auto"};
	top: ${(props) => (props.$inDrawer ? "auto" : 0)};
	overflow: ${(props) => (props.$inDrawer ? "visible" : "hidden")};
	overflow-y: ${(props) => (props.$inDrawer ? "visible" : "scroll")};
	background-color: #fff;
	padding: 24px;
	z-index: ${(props) => (props.$inDrawer ? "auto" : 1000)};
	.backAction {
		margin-bottom: 24px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		cursor: pointer;
		> div {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #435363;
			width: 30px;
			height: 30px;
			font-size: 20px;
		}
	}
	form {
		width: 100%;
		.containerFormElements {
			display: flex;
			flex-direction: column;
			gap: 24px;
		}
	}
`
